/* --- QUESTIONNAIRE CONFIG --- */

export interface QuestionnaireClinicalSccai {
  position: number;
  question: string;
  answers: string[];
}

export const Q_CLINICAL_SCCAI: QuestionnaireClinicalSccai[] = [
  {
    // tslint:disable-next-line:max-line-length
    position: 1, question: 'Quante evacuazioni ha avuto durante il giorno (cioè da quando si è svegliato a quando è andato a dormire) negli ultimi 3 giorni? Vanno considerate anche le evacuazioni solo di muco o di sangue.' ,
    answers: [
      '0-3 evacuazioni',
      '4-6 evacuazioni',
      '7-9 evacuazioni',
      'oltre 9 evacuazioni'

    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 2, question: 'Quante evacuazioni ha avuto durante la notte (da quando si è coricato per dormire al risveglio, quante volte si è dovuto alzare per andare in bagno) nelle ultime 3 notti?',
    answers: [
      'nessuna',
      '1-3 evacuazioni',
      '4 o più evacuazioni'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 3, question: 'Quanta urgenza all’evacuazione ha accusato negli ultimi 3 giorni? (Cioé, quanto deve correre quando ha lo stimolo ad evacuare)',
    answers: [
      'Non ho alcuna urgenza evacuativa',
      'Devo andare velocemente in bagno',
      'Non posso aspettare per andare in bagno',
      'Ho episodi di incontinenza (non riesco a controllare l’urgenza e mi è capitato di perdere le feci)'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 4, question: 'Quanto sangue ha visto nelle feci negli ultimi 3 giorni?',
    answers: [
      'Nulla',
      'Sangue in tracce (una macchia o una piccola quantità)',
      'Sangue più abbondante (talvolta abbondante o anche solo sangue)',
      'Sanguinamento grave (sangue sempre abbondante o evacuazioni solo di sangue)'
    ]
  },
  {
    position: 5, question: 'Benessere generale (come si sente in generale con la Sua salute?',
    answers: [
      'Molto bene',
      'Un po’ meno bene del solito',
      'Male',
      'Piuttosto male',
      'Malissimo',
    ]
  },
  {
    position: 6, question: 'a) Problemi articolari (ha avuto dolore, arrossamento o gonfiore articolare)?',
    answers: [
      'Si', 'No'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 7, question: 'b) Problemi oculari (occhi rossi, dolorosi o fastidiosi)? Altri sintomi possono essere visione offuscata, sensibilità alla luce, carenza o eccesso di lacrimazione*',
    answers: [
      // tslint:disable-next-line:max-line-length
      'Si',
      'No'
    ]
  },
  {
    position: 8, question: 'c) Problemi orali (ha avuto afte in bocca)? Le afte sono aree giallastre rotonde, circondate da un alone rosso',
    answers: [
      'Si', 'No'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 9, question: 'd) Ha avuto delle ulcerazioni in genere profonde, violacee che si sono sviluppate improvvisamente (o le è stata fatta diagnosi di pioderma gangrenoso)?',
    answers: [
      'Si', 'No'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 10, question: 'e) Ha avuto delle sorte di lividi rilevati molto dolenti, soprattutto agli arti inferiori (o le è stata fatta diagnosi di eritema nodoso?',
    answers: [
      'Si', 'No'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 11, question: 'f) Problemi perianali (ha avuto ferite o fissurazioni della pelle anale o ascessi (aree arrossate dolenti perianali)',
    answers: [
      'Si', 'No'
    ]
  }
];

/* ------------ RESULTS CONFIGURATION + CONSTRUCTOR ------------ */

export class ClinicalSccaiResults {
  patientSSN: string;
  doctorID: string;
  results: string[];
  finalScore: number;

  constructor(doctorID: string, patientSSN: string, results: string[], finalScore: number) {
    this.doctorID = doctorID;
    this.patientSSN = patientSSN;
    this.results = results;
    this.finalScore = finalScore;
  }

}
